import { render, staticRenderFns } from "./action-wrapper.vue?vue&type=template&id=66d95c56&"
var script = {}
import style0 from "./action-wrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports